import type { ReactNode } from 'react'
import { SidebarHeader } from '#src/pages/inbox/detail/SidebarHeader.tsx'

/* Simple shell wrapper for loading / fallback states */
export function DetailPanelShell({
  onClose,
  children,
}: {
  onClose: () => void
  children: ReactNode
}): ReactNode {
  return (
    <div className="flex h-full flex-col border-l border-border bg-background">
      <SidebarHeader title="Loading..." onClose={onClose} />
      <div className="flex flex-1 items-center justify-center">{children}</div>
    </div>
  )
}
